import { render, staticRenderFns } from "./Notice_Test.Detail.vue?vue&type=template&id=3c1d50d0&"
import script from "./Notice_Test.Detail.vue?vue&type=script&lang=js&"
export * from "./Notice_Test.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports